<div fxLayout="column" [dragAndDrop]="true" (dropped)="onDropped($event)" [formGroup]="formGroup">

  @if (!hasAttachments) {
    <div fxLayout="column" fxLayoutAlign="center center">
      <img alt="Illustration of container full of paper clips"
        src="https://cdn.forge.tylertech.com/v1/images/spot-hero/no-attachments-1-empty-state-spot-hero.svg"
        style="height: 30vh;">
        <div class="forge-typography--heading2 tt-margin--bottom">
          Uh oh, there are no attachments.
        </div>
        @if (canEdit) {
          <div class="forge-typography--heading2 tt-margin--bottom">
            Click below to add a file.
          </div>
        }
      </div>
    }

    <div formArrayName="attachments">
      @for (attachment of attachments; track attachment; let i = $index) {
        @if (!attachment.IsDeleted) {
          <attachment [canEdit]="canEdit" [entityType]="entityType" [index]="i"
            (delete)="onDelete(attachment)">
          </attachment>
        }
      }
    </div>

    @if (canAdd) {
      <div fxLayout="column" fxLayoutAlign="center center" class="attachment-commands">
        <input #fileInput type="file" hidden controlName="addFile" (change)="onFileSelected($event)" [multiple]="true" telemetry="Edit-InputFile">
        <command [command]="addFileCommand"></command>
      </div>
    }
  </div>
